import BaseService from "./base-service";
import { RequestDto } from "./dto/request/request-dto";
import { LoginResponseDTO } from "./dto/response/auth/login-response-dto";

interface LoginDTO {
  Email: string;
  Password: string;
  Portal?: string;
  TurnstileToken?: string;
}

export interface RegisterManagerDTO {
  email: string;
  name: string;
  lastName: string;
  phone: string;
  nameCompany: string;
  address: string;
  cuitCuil: string;
  countryId: string;
  countryCode: string;
  turnstileToken?: string;
}

export interface RegisterResponseDTO {
  message: string;
  success: boolean;
}

export class AuthService extends BaseService {
  private resource = "/auth";

  async login(
    params: LoginDTO,
    onSuccess: (data: LoginResponseDTO) => void,
    onError: (errorMessage: string) => void
  ): Promise<void> {
    params.Portal = 'manager';
    const reqParams = new RequestDto(this.resource + "/login", params);
    await this.doPost<LoginResponseDTO>(reqParams, onSuccess, onError);
  }

  async registerManager(
    params: RegisterManagerDTO,
    onSuccess: (data: RegisterResponseDTO) => void,
    onError: (errorMessage: string) => void
  ): Promise<void> {
    const formData = new FormData();
    formData.append('name', params.name);
    formData.append('lastName', params.lastName);
    formData.append('email', params.email);
    formData.append('nameCompany', params.nameCompany);
    formData.append('address', params.address);
    formData.append('phone', params.phone);
    formData.append('cuitCuil', params.cuitCuil);
    formData.append('countryId', params.countryId);
    formData.append('countryCode', params.countryCode);
    formData.append('isResponsible', 'true');
    if (params.turnstileToken) {
      formData.append('TurnstileToken', params.turnstileToken);
    }

    const reqParams = new RequestDto("/manager", formData, {
      'Content-Type': 'multipart/form-data'
    });
    await this.doPost<RegisterResponseDTO>(reqParams, onSuccess, onError);
  }
}
